import React, { useContext, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Calendar from 'react-calendar';
import { DataContext } from '../contexts/DataContext';
import 'react-calendar/dist/Calendar.css';
import './ShipmentArrivalCalendar.css';

const ShipmentArrivalCalendar = () => {
  const { data, isLoading } = useContext(DataContext);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data for calendar markings and details
  const etaDates = new Map();
  data.forEach(item => {
    const etaDate = item.dates_pedimento.eta_date;
    const paidDate = item.dates_pedimento.paid_date;
    const status = paidDate ? 'arrived' : 'expected';
    if (etaDate) {
      if (!etaDates.has(etaDate)) {
        etaDates.set(etaDate, { status: [], details: [] });
      }
      etaDates.get(etaDate).status.push(status);
      etaDates.get(etaDate).details.push({
        customerName: item.customer_data.customer_name,
        containerNumber: item.container_data.map(c => c.container_number.trim()).join(', '),
        etaDate: etaDate, 
        paidDate: paidDate 
      });
    }
  });

  const handleDayClick = (value) => {
    const dateString = value.toISOString().split('T')[0];
    if (etaDates.has(dateString)) {
      setSelectedShipments(etaDates.get(dateString).details);
      setIsModalOpen(true);
    }
  };

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const dateString = date.toISOString().split('T')[0];
      const currentDate = new Date();
  
      if (etaDates.has(dateString)) {
        console.log(`Checking shipments for date: ${dateString}`);
  
        const hasArrived = etaDates.get(dateString).details.some(shipment => {
          console.log(`Shipment details:`, shipment);
  
          const etaDate = shipment.etaDate ? new Date(shipment.etaDate) : null;
          const paidDate = shipment.paidDate ? new Date(shipment.paidDate) : null;
  
          console.log(`Parsed etaDate: ${etaDate}, parsed paidDate: ${paidDate}`);
  
          if (etaDate && paidDate && !isNaN(paidDate.getTime())) {
            const isArrived = etaDate <= currentDate;
            console.log(`Is shipment arrived? ${isArrived}`);
            return isArrived;
          }
  
          return false;
        });
  
        console.log(`hasArrived for ${dateString}: ${hasArrived}`);
        return hasArrived ? 'custom-green-background' : 'custom-yellow-background';
      }
    }
    return '';
  };
  
  
  
  
  
  return (
    <div className="bg-white shadow rounded-lg h-custom-card-big p-4 w-full max-w-lg">
      <div className="mb-4 text-lg font-bold text-gray-800 flex items-center">
        <FontAwesomeIcon icon={faCalendarAlt} className="text-blue-600 mr-2" />
        Shipment Arrival Calendar
      </div>
      <Calendar
        onClickDay={handleDayClick}
        tileClassName={tileClassName}
      />
      {isModalOpen && (
        <div className="modal bg-white p-4 rounded shadow-lg">
          <h2 className="text-lg font-bold mb-4">Shipment Details</h2>
          <table className="min-w-full table-auto">
            <thead>
              <tr>
                <th className="px-4 py-2 border">Customer Name</th>
                <th className="px-4 py-2 border">Container Number</th>
              </tr>
            </thead>
            <tbody>
              {selectedShipments.map((shipment, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2">{shipment.customerName}</td>
                  <td className="border px-4 py-2">{shipment.containerNumber}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded" onClick={() => setIsModalOpen(false)}>
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default ShipmentArrivalCalendar;
